export const autoApprovalLevelOptions = {
  YEARLY: "Yearly",
  MONTHLY: "Monthly",
  TRANSACTION: "Transaction",
};
